import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  marketSummary: null,
  marketStatus: null,
  marketOverviewStatus: null,
  watchList: null,
  portfolioSummary: null,
  portfolioPostionSummary: null,
  orderBasketList: null,
  markets: null,
  selectedMarket: null,
  tradingLoading: false,
  watchListDropdowns: null,
  marketDetails: null,
  calculateLoading: null,
  calculatedOrderAmount: null,
  portfolioDropdowns: null,
  marketSymbolsData: null,
  marketValues: null,
  globalSetting: null,
};

const tradingSlice = createSlice({
  name: "trading",
  initialState,
  reducers: {
    setTradingLoading: (state, action) => {
      state.tradingLoading = action.payload;
    },
    setMarketSummary: (state, action) => {
      state.marketSummary = action.payload;
    },
    setMarketStatus: (state, action) => {
      state.marketStatus = action.payload;
    },
    setMarketOverviewStatus: (state, action) => {
      state.marketOverviewStatus = action.payload;
    },
    setPortfolioSummary: (state, action) => {
      state.portfolioSummary = action.payload;
    },
    setWatchList: (state, action) => {
      state.watchList = action.payload;
    },
    setPortfolioPositionSummary: (state, action) => {
      state.portfolioPostionSummary = action.payload;
    },
    setOrderBasketList: (state, action) => {
      state.orderBasketList = action.payload;
    },
    setMarkets: (state, action) => {
      state.markets = action.payload;
    },
    setSelectedMarket: (state, action) => {
      state.selectedMarket = action.payload;
    },
    setWatchListDropdowns: (state, action) => {
      state.watchListDropdowns = action.payload;
    },
    setMarketDetails: (state, action) => {
      state.marketDetails = action.payload;
    },
    setCalculateLoading: (state, action) => {
      state.calculateLoading = action.payload;
    },
    setCalculatedOrderAmount: (state, action) => {
      state.calculatedOrderAmount = action.payload;
    },
    setPortfolioDropdowns: (state, action) => {
      state.portfolioDropdowns = action.payload;
    },
    setMarketSymbolsData: (state, action) => {
      state.marketSymbolsData = action.payload;
    },
    setMarketValues: (state, action) => {
      state.marketValues = action.payload;
    },
    setGlobalSetting: (state, action) => {
      state.globalSetting = action.payload;
    },
  },
});

export const {
  setMarketSummary,
  setMarketStatus,
  setMarketOverviewStatus,
  setPortfolioSummary,
  setWatchList,
  setPortfolioPositionSummary,
  setOrderBasketList,
  setMarkets,
  setSelectedMarket,
  setTradingLoading,
  setWatchListDropdowns,
  setMarketDetails,
  setCalculateLoading,
  setCalculatedOrderAmount,
  setPortfolioDropdowns,
  setMarketSymbolsData,
  setMarketValues,
  setGlobalSetting,
} = tradingSlice.actions;
export default tradingSlice.reducer;
